var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVasCorporateService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd9hu73nla)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.846 38.002 4.88 28.55l4.846-2.927 5.083 9.39-4.964 2.989z",
    fill: "url(#w96y0v92tb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.82 24.022-3.571 2.865 4.065 7.36 9.891-.052a4.867 4.867 0 0 0 3.353-1.35l7.986-7.703a2.31 2.31 0 0 0 .128-3.216c-.937-1.056-2.61-1.101-3.607-.098l-6.018 6.052c.914-1.048.173-2.655-1.243-2.696l-3.507-.102a.677.677 0 0 1-.604-.402l-.032-.074c-.385-.89-1.293-1.46-2.29-1.437l-2.347.055a3.66 3.66 0 0 0-2.203.798z",
    fill: "url(#pwtnxzak2c)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.933 37.806-.625-1.602 4.887-3.048.745 1.539-5.007 3.111z",
    fill: "url(#d2kzgrtm3d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.08 33.13h-9.14l-.5-.834 9.225-.159a4.828 4.828 0 0 0 3.362-1.445l9.004-9.17.814.834-9.35 9.358a4.828 4.828 0 0 1-3.416 1.415z",
    fill: "url(#sqvgjb8ive)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m9.62 25.049 3.99-3.424a3.62 3.62 0 0 1 2.357-.873h3.002c1.109 0 2.14.603 2.695 1.561.176.303.498.496.848.504l2.278.051a2.791 2.791 0 0 1 2.673 2.239m-9.52 3.34h6.785a2.79 2.79 0 0 0 2.735-3.34m-.007.006.007-.006m0 0 4.81-4.335a2.555 2.555 0 0 1 3.514 3.709l-7.992 7.957a4.828 4.828 0 0 1-3.381 1.407l-9.975.054m-9.637-4.95L8.6 35.82a2.414 2.414 0 0 0 3.35.905l1.089-.65a2.414 2.414 0 0 0 .861-3.264l-3.873-6.827a2.414 2.414 0 0 0-3.342-.879l-1.012.608a2.414 2.414 0 0 0-.871 3.238zm10.92-11.266 9.38.048a1.207 1.207 0 0 0 1.178-1.49l-.434-1.799a4.828 4.828 0 0 0-4.693-3.693h-1.395a4.828 4.828 0 0 0-4.638 3.487l-.55 1.904a1.207 1.207 0 0 0 1.153 1.543zm8.073-11.188c0 1.93-1.527 3.495-3.41 3.495-1.884 0-3.412-1.565-3.412-3.495 0-1.93 1.528-3.495 3.411-3.495 1.884 0 3.411 1.565 3.411 3.495z",
    stroke: "url(#0uo056slvf)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "w96y0v92tb",
    x1: 28.167,
    y1: 47.054,
    x2: 4.037,
    y2: 29.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pwtnxzak2c",
    x1: 28.167,
    y1: 47.054,
    x2: 4.037,
    y2: 29.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d2kzgrtm3d",
    x1: 29.741,
    y1: 46.53,
    x2: 7.237,
    y2: 31.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sqvgjb8ive",
    x1: 29.741,
    y1: 46.53,
    x2: 7.237,
    y2: 31.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0uo056slvf",
    x1: 28.274,
    y1: 55.316,
    x2: -4.894,
    y2: 43.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd9hu73nla"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVasCorporateService);
export default __webpack_public_path__ + "static/media/vasCorporateService.b067f7a126e6416e877201d83e10d35a.svg";
export { ForwardRef as ReactComponent };